
/* injects from baggage-loader */

'use strict';

import _ from "lodash";

export default class StageBaseController {
	constructor($log, $state, $q, Session, Dialog) {
		'ngInject';

		this.$log = $log;
		this.$state = $state;
		this.$q = $q;
		this.Session = Session;
		this.Dialog = Dialog;
		this.hey = false;
	}

	getNumber(num){		
		if(num > 0){
			return new Array(num);
		}
		else{
			return new Array(1);
		}
	}

	checkGrid(obj){
		let num = obj.value;
		if(num<=12){
			obj.parentStyle['justify-content'] = 'center';
			obj.style.width = '80px';
			obj.style.height = '80px';
			obj.style.padding = '2xp';
		}
		else if(num<=40){
			obj.parentStyle['justify-content'] = 'flex-start';
			obj.style.width = '48px';
			obj.style.height = '48px';
			obj.style.padding = '2xp';
		}
		else if(num<=90){
			obj.parentStyle['justify-content'] = 'flex-start';
			obj.style.width = '32px';
			obj.style.height = '32px';
			obj.style.padding = '2xp';
		}
		else if(num<=160){
			obj.parentStyle['justify-content'] = 'flex-start';
			obj.style.width = '24px';
			obj.style.height = '24px';
			obj.style.padding = '2xp';
		}
		else if(num<=286){
			obj.parentStyle['justify-content'] = 'flex-start';
			obj.style.width = '18px';
			obj.style.height= '18px';
			obj.style.padding = '2xp';
		}
		else if(num<=416){
			obj.parentStyle['justify-content'] = 'flex-start';
			obj.style.width = '15px';
			obj.style.height = '15px';
			obj.style.padding = '1xp';
		}
		else if(num<=640){
			obj.parentStyle['justify-content'] = 'flex-start';
			obj.style.width = '12px';
			obj.style.height = '12px';
			obj.style.padding = '0xp';
		}
		else if(num<=960){
			obj.parentStyle['justify-content'] = 'flex-start';
			obj.style.width = '10px';
			obj.style.height = '10px';
			obj.style.padding = '0px';
		}
		return false;
	}

	showHelp(){
		this.Dialog.showTutorial('m3');
	}

	updateRelation(obj){
		let $ctrl = this;
		return this.$q(function(resolve) {
			let objsToUp = $ctrl.elements.filter(o => o!==obj);
			objsToUp.forEach(function(o){
				let aux = $ctrl.relation;
				if(o.maxValue < obj.maxValue){
					o.value = Math.floor(1/aux * obj.value);
				} else {
					o.value = Math.floor(aux * obj.value);
				}
			});
			resolve(objsToUp);
		});
	}
	
	checkStage(){
		let session = this.Session.get();
		// this.$log.log(session);
		if(session!==undefined){
			let stages = this.Session.get().stages;
			for(let i = stages.length-1; i>=0; i--){
				if(stages[i].unlocked){
					this.stageName = stages[i].name;
					this.prepareQuestion(this.stageName);
					break;
				}
			}
		}
	}
	
	update(ob){
		let num = ob.value;
		if(num<1)
			ob.value = "";
		else if(num>ob.maxValue){
			ob.value = ob.maxValue;
		}
		let promise = this.updateRelation(ob);
		promise.then(()=>this.elements.forEach(o => this.checkGrid(o)));
	}

	checkValue(){
		let awnser = this.awnserValue;
		if(awnser !== ""){
			if(awnser === this.relation * this.expected){
				this.setSession(this.sessionToSave);
				this.stageCompleted();
				this.Dialog.showFeedback(this.prize, this.goHome.bind(this));
			}
			else{
				this.Dialog.showAlert();
			}
		}
	}

	stageCompleted(){
		let { stages } = this.Session.get();
		let session = this.Session.get();
		let stageIndex = _.findIndex(stages, { name: this.stageName });
		let nextStageIndex = stageIndex + 1;
		let stageModel = stages[stageIndex];
		let nextStageModel = stages[nextStageIndex];

		if(nextStageModel !== undefined)
			stages[nextStageIndex] = _.merge(nextStageModel, { unlocked: true });
		stages[stageIndex] = _.merge(stageModel, { completed: true });

		let updates = _.merge(session, { stages: stages });
		this.Session.save(updates, true);
	}

	// checkValue(){
	// 	let awnser = this.awnserValue;
	// 	if(awnser !== ""){
	// 		if(awnser === 1/this.relation * this.expected){
	// 			this.setSession();
	// 			this.Dialog.showFeedback(this.prize, this.goHome.bind(this));
	// 		}
	// 		else{
	// 			this.Dialog.showAlert();
	// 		}
	// 	}
	// }

	goHome(){
		this.$state.go("main");
	}

	goHomeBtn(){
		this.Session.setDialog(false);
		this.$state.go("main");
	}

	modify(ob,num){
		if(ob.value>0)
			ob.value = ob.value+num;
		else{
			ob.value = 0;
			ob.value = ob.value+num;
		}
		this.update(ob);

		return false;
	}

	getRandomInt(ar) {
		let min = Math.ceil(ar[0]);
		let max = Math.floor(ar[1]);
		return Math.floor(Math.random() * (max - min)) + min;
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/stage-base.controller.js